/**
 * Usage-string formatting is owned by the shared compliance rule; we re-export
 * it rather than re-implement the "used / cap (∞ for unlimited)" contract, so
 * there is a single source of truth across API, DB parity test, and web.
 */
export { formatUsage } from '@worklogix/shared';

/**
 * Format an ISO-8601 timestamp as a short, locale-aware calendar date for
 * display in resource grids and blade headers. Falls back to the raw value when
 * the input is not a parseable date so the UI never renders "Invalid Date".
 */
export function formatDate(iso: string): string {
  const ms = Date.parse(iso);
  if (Number.isNaN(ms)) {
    return iso;
  }
  return new Date(ms).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}
